export const GET_CREDIT_NOTE_ITEM = gql`
    query GetCreditNote($id: Int!) {
        creditNoteItem(id: $id) {
            id
            invoiceToType
            reason
            createdAt
            updatedAt
            sageCreditNoteId
            status
            partner {
                id
                name
                business {
                    id
                    legalName
                }
                firstName
                lastName
                primaryContactInformation
                billingContactInformation
            }
            merchant {
                id
                application {
                    merchantInformation
                }
            }
            creditNoteItems {
                totalNet
                description
                ledgerAccount
                totalVat
                quantity
                netAmount
                lineTotal
            }

            salesInvoice {
                id
                to
                sageInvoiceNumber
                status
                invoiceItems {
                    totalVat
                    updatedAt
                    createdAt
                    ledgerAccount
                    id
                    lineTotal
                    netAmount
                    quantity
                    totalNet
                }
            }
            totalCreditNetAmount
            totalCreditVatAmount
            totalCreditAmount
        }
    }
`;
export const GET_CREDIT_NOTE_PDF = gql`
    query viewPDFCreditNote($sageCreditNoteId: String) {
        viewPDFCreditNote(sageCreditNoteId: $sageCreditNoteId) {
            pdfBase64
            previewUrl
        }
    }
`;
